import { createEventBus, getLatestFromTopic } from "./event-bus";
export const createEventBusHook = ({ useState, useEffect, useCallback, }) => (topic, initialValue) => {
    if (initialValue === undefined) {
        initialValue = getLatestFromTopic(topic);
    }
    const { observe, dispatch } = createEventBus();
    const [data, _setData] = useState(initialValue);
    const setData = useCallback((data) => dispatch(topic, data), []);
    useEffect(() => {
        const unsubscribe = observe(topic, (data) => _setData(data));
        return () => unsubscribe();
    }, [topic]);
    return [data, setData];
};
//# sourceMappingURL=event-bus-hook.js.map